import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import coordinatorImg from '../assets/coordinator-meltem.jpg';

const CoordinatorPage = () => {
    // Scroll to top when page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-white min-h-screen flex flex-col font-sans">

            {/* Dark Header Section with Navbar and Title */}
            <div className="bg-[#0f172a] relative pb-24">
                <Navbar />

                <div className="container mx-auto px-6 pt-32 pb-12 text-center relative z-10">
                    <motion.h1
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-3xl md:text-4xl font-bold text-white tracking-wide font-heading"
                    >
                        Topluluk Koordinatörümüzün Mesajı
                    </motion.h1>
                </div>

                {/* Decorative bottom shape/border if needed, or simple straight edge as per ref */}
            </div>

            {/* White Content Section */}
            <main className="flex-grow container mx-auto px-6 pt-16 pb-48 md:pt-24 md:pb-56 -mt-20 relative z-20">
                <div className="flex flex-col md:flex-row gap-12 lg:gap-16 items-center">

                    {/* Left Column: Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="w-full md:w-1/3 lg:w-[400px] flex-shrink-0"
                    >
                        <div className="sticky top-24">
                            <img
                                src={coordinatorImg}
                                alt="Doç. Dr. Meltem ALTINAY ÖZDEMİR"
                                className="w-full h-auto rounded-lg shadow-2xl object-cover"
                            />
                            <div className="mt-6 text-center md:text-left">
                                <h3 className="text-lg font-bold text-gray-900">Doç. Dr. Meltem ALTINAY ÖZDEMİR</h3>
                                <p className="text-cyan-600 font-medium mt-1">Topluluk Koordinatörü</p>
                            </div>
                        </div>
                    </motion.div>

                    {/* Right Column: Text Content */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="flex-1 text-gray-700 leading-relaxed text-base space-y-6"
                    >
                        <p className="font-medium text-gray-900 text-lg">
                            Değerli Geleceğin Rehberleri,
                        </p>

                        <p>
                            Muğla Sıtkı Koçman Üniversitesi Turist Rehberliği Topluluğu (TURET), 2019 yılında Muğla Sıtkı Koçman Üniversitesi Sağlık, Kültür ve Spor Daire Başkanlığı’na (SKS) bağlı olarak, turist rehberliği mesleğinin akademik, kültürel ve mesleki yönlerini desteklemek amacıyla kurulmuştur. Kurulduğu günden bu yana topluluğumuz, öğrencilerimizin mesleki donanımlarını geliştirmeyi, kültürel farkındalıklarını artırmayı ve sektörle olan bağlarını güçlendirmeyi hedefleyen birçok nitelikli çalışmayı başarıyla gerçekleştirmiştir.
                        </p>

                        <p>
                            Turist rehberliği; yalnızca bilgi aktarımını değil, aynı zamanda kültürel mirasın korunmasını, doğru ve etik bir anlayışla aktarılmasını ve sürdürülebilir turizm bilincinin benimsenmesini gerektiren çok yönlü bir meslektir. Bu doğrultuda TURET, akademik bilgi ile uygulamayı bir araya getiren etkinlikler aracılığıyla öğrencilerimizin mesleğe bilinçli, sorumluluk sahibi ve donanımlı bireyler olarak hazırlanmalarına katkı sağlamaktadır.
                        </p>

                        <p>
                            Topluluk bünyesinde düzenlenen seminerler, söyleşiler, teknik geziler ve sosyal-kültürel etkinlikler sayesinde öğrencilerimizin hem mesleki hem de kişisel gelişimleri desteklenmekte; üniversite, sektör ve öğrenciler arasında güçlü bir iş birliği ve iletişim ortamı oluşturulmaktadır.
                        </p>

                        <p>
                            Bu süreçte emeği geçen tüm öğrenci üyelerimize, yönetim kurullarımıza ve desteklerini esirgemeyen akademik ve sektörel paydaşlarımıza teşekkür eder; TURET’in, Muğla Sıtkı Koçman Üniversitesi çatısı altında, turist rehberliği alanında nitelikli ve bilinçli bireyler yetiştirme misyonunu aynı kararlılıkla sürdürmeye devam edeceğine olan inancımı ifade etmek isterim.
                        </p>
                    </motion.div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default CoordinatorPage;
